import React from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Layout } from 'antd';
import PrivateRoute from 'components/PrivateRoute';
import mainRoutes from 'routes/mainRoutes';
import Banner from './containers/Banner';
import Why from './containers/Why';
import WhyNow from './containers/WhyNow';
import ThisWay from './containers/ThisWay';
import Resources from './containers/Resources';
import ScheduleDemo from './containers/ScheduleDemo';
import Footer from './containers/Footer';
import ContactUs from './containers/Contact';
import Privacy from './containers/Privacy';
import Home from './containers/Home';

export default function App() {
  return (
    <Router>
      <Switch>
        <Route path="/privacy">
          <Privacy />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}
